import React, { useEffect } from "react";
import Footer from "./Footer";
import MainHeader from "./MainHeader";
import { Outlet, useLocation } from "react-router";
import { HashLink } from "react-router-hash-link";
import { useTranslation } from "react-i18next";
import Button from "components/Button";
import appConfig from "config/appConfig";
import { paths } from "constants";
import CookiesBanner from "./CookiesBanner";
import { LanguageProvider, stripLocaleFromPath } from "i18n/LanguageContext";

const validPaths = Object.values(paths);

const headerColor = (pathName) => {
  const stripped = stripLocaleFromPath(pathName);
  const rootPath = stripped.split("/")[1];
  if (rootPath === "analyse") return "default";
  return validPaths.includes(stripped) ? "default" : "inverted";
};

const LayoutInner = () => {
  const location = useLocation();
  const { t } = useTranslation("common");

  useEffect(() => {
    window.scroll(0, 0);
  }, [location.pathname]);

  return (
    <div
      className={`relative flex flex-col justify-between min-h-screen ${
        appConfig.layout.header.fixed ? "pt-28" : ""
      }`}
    >
      <HashLink
        style={{ zIndex: 51 }}
        className="absolute top-2 left-1 -translate-x-96 focus:translate-x-0 transition-all"
        to="/#main"
      >
        <Button
          element="div"
          variant="outlined"
          size="sm"
          className="font-medium"
        >
          {t("cta.skipNavigation")}
        </Button>
      </HashLink>
      {appConfig.layout.header.visible && (
        <MainHeader
          color={headerColor(location.pathname)}
          fixed={appConfig.layout.header.fixed}
        />
      )}
      <div className="flex-1">
        <Outlet />
      </div>

      <CookiesBanner />
      {appConfig.layout.footer.visible && (
        <Footer fixed={appConfig.layout.footer.visible} />
      )}
    </div>
  );
};

const Layout = () => (
  <LanguageProvider>
    <LayoutInner />
  </LanguageProvider>
);

export default Layout;
